import { axiosInstance } from "../../../axiosConfig";

// Not a standard CRUD action, so it bypasses dataProvider (like
// createWithId/updateRecord in creatorsShared) - see pl-back's
// ServiceController's PATCH /reorder route and ServiceService.reorder.
export const reorderServices = (ids: string[]) =>
  axiosInstance.patch("/api/v1/services/reorder", { ids });
